import { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import { centsToDollarsDisplay } from "../../../common/helpers/stringUtils";
import Condition from "../../Conditional/Condition";
import "./ItemAndPrice.scss";

interface IProps {
	label: string;
	price: number;
	className?: string;
}

const ItemAndPrice = ({ label, price, className }: IProps): ReactElement => {
	const { t } = useTranslation();

	return (
		<div className={`ItemAndPrice ${className ?? ""}`}>
			<div className="ItemAndPriceLabel">{t(label)}</div>
			<Condition check={!!price}>
				<div>{`$${centsToDollarsDisplay(price)}`}</div>
			</Condition>
		</div>
	);
};

export default ItemAndPrice;
